const type = 'SET_ADVANCE_INVOICE_INSTALLMENT_SUBMITTING';

const setAdvanceInvoiceInstallmentSubmitting = (data) => ({
  data,
  type,
});

export { type };
export default setAdvanceInvoiceInstallmentSubmitting;
